import {
  Page,
  View,
  Image,
} from "@react-pdf/renderer";
import React from "react";
import { styles } from "./PageLayoutStyle";
import headerImg from "./assets/header.jpg";
import footerImg from "./assets/footer.jpg";

const PageLayout = ({ children, pageNo, company }) => {

  function returnSrc(path = "") {
    return {
      uri: path,
      method: "GET",
      body: "",
      headers: { "Cache-Control": "no-cache" },
    };
  }
  return (
    <Page size="A4" style={styles?.page} wrap>
      <View style={styles?.header} fixed>
        <Image
          src={
            company?.header && company?.header != ""
              ? returnSrc(company?.header)
              : headerImg
          }
          style={styles?.logo1}
        />
      </View>
     
      {children}
       
      <View style={styles?.footer} fixed>
        <Image
          src={
            company?.footer && company?.footer != ""
              ? returnSrc(company?.footer)
              : footerImg
          }
          style={styles?.logo1}
        />
      </View>
    </Page>
  );
};

export default PageLayout;
